import api from './api';

export interface MotivoDesconto {
  id: number;
  descricao: string;
  ativo: boolean;
  is_default?: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface MotivoDescontoSelect {
  value: number;
  label: string;
  is_default?: boolean;
}

class MotivoDescontoService {
  async getMotivosAtivos(): Promise<MotivoDesconto[]> {
    try {
      const response = await api.get('/motivos-desconto/ativas');
      return response?.data || [];
    } catch (error) {
      console.error('Erro ao buscar motivos de desconto ativos:', error);
      return [];
    }
  }

  async getMotivosParaSelect(): Promise<MotivoDescontoSelect[]> {
    try {
      const response = await api.get('/motivos-desconto/select');
      return response?.data || [];
    } catch (error) {
      console.error('Erro ao buscar motivos de desconto para select:', error);
      return [];
    }
  }

  async getAllMotivos(params?: {
    page?: number;
    limit?: number;
    search?: string;
    ativo?: boolean;
  }): Promise<{
    motivos: MotivoDesconto[];
    pagination: { total: number; page: number; limit: number; pages: number };
  }> {
    try {
      const response = await api.get('/motivos-desconto', { params });
      return response?.data || { motivos: [], pagination: { total: 0, page: 1, limit: 10, pages: 0 } };
    } catch (error) {
      console.error('Erro ao buscar motivos de desconto:', error);
      return { motivos: [], pagination: { total: 0, page: 1, limit: 10, pages: 0 } };
    }
  }

  async createMotivo(data: { descricao: string; ativo?: boolean; is_default?: boolean }): Promise<MotivoDesconto> {
    const response = await api.post('/motivos-desconto', data);
    return response?.data;
  }

  async updateMotivo(id: number, data: Partial<MotivoDesconto>): Promise<MotivoDesconto> {
    const response = await api.put(`/motivos-desconto/${id}`, data);
    return response?.data;
  }

  async deleteMotivo(id: number): Promise<void> {
    await api.delete(`/motivos-desconto/${id}`);
  }

  async toggleAtivo(id: number): Promise<MotivoDesconto> {
    const response = await api.patch(`/motivos-desconto/${id}/toggle-ativo`);
    return response?.data;
  }
}

export default new MotivoDescontoService();
